import React from 'react';

const colors: Record<string, string> = {
  green: 'bg-green-100 text-green-700',
  red: 'bg-red-100 text-red-700',
  yellow: 'bg-yellow-100 text-yellow-700',
  blue: 'bg-emerald-100 text-emerald-700',
  gray: 'bg-gray-100 text-gray-600',
  purple: 'bg-purple-100 text-purple-700',
};

const statusColors: Record<string, string> = {
  active: 'green', online: 'green', connected: 'green', paid: 'green', answered: 'green', occupied: 'blue', trialing: 'blue', trial: 'blue', setup: 'yellow',
  inactive: 'gray', offline: 'gray', vacant: 'gray', canceled: 'gray', void: 'gray',
  suspended: 'red', error: 'red', disconnected: 'red', denied: 'red', overdue: 'red', past_due: 'red',
  pending: 'yellow', missed: 'yellow', open: 'yellow',
};

export const Badge: React.FC<{ status?: string; color?: string; children: React.ReactNode }> = ({ status, color, children }) => {
  const c = color || (status ? statusColors[status] || 'gray' : 'gray');
  return <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${colors[c]}`}>{children}</span>;
};
